export default __webpack_public_path__ + "static/media/art_image2.2df000cd.jpg";